import type { BlogPost } from "./blog";

export const BLOG_RESTAURANTS_PART3: BlogPost[] = [
  {
    "slug": "restorany-petrogradskaya-spb",
    "title": "Рестораны на Петроградской стороне СПб: лучшие места",
    "metaTitle": "Рестораны на Петроградской стороне СПб 2026 | Паруса на крыше",
    "metaDescription": "Лучшие рестораны Петроградской стороны Санкт-Петербурга: где поесть, цены, атмосфера. Обзор по кухне и поводу.",
    "keywords": "рестораны петроградская сторона, рестораны петроградская спб, где поесть петроградская",
    "date": "2026-06-02",
    "category": "Рестораны Петербурга",
    "readTime": 7,
    "image": "/photos/view_day.webp",
    "lead": "Петроградская сторона — один из самых самобытных районов Санкт-Петербурга. Каменноостровский проспект, уютные переулки, близость к Петропавловской крепости создают особую атмосферу. Рестораны здесь разнообразны: от бюджетных кафе до полноценных ресторанов с авторской кухней.",
    "sections": [
      {
        "heading": "Особенности района",
        "body": "Петроградская сторона исторически считается интеллигентным районом Петербурга. Здесь много жилых домов в стиле модерн, камерных улиц и скверов. Ресторанная жизнь сосредоточена вдоль Каменноостровского проспекта и в районе Петроградского метро. Публика тут другая, чем на Невском: больше местных жителей и меньше туристов.",
        "list": [
          "Каменноостровский проспект — главная ресторанная улица района",
          "Много кафе и баров с уютной атмосферой для местных",
          "Близость к ЗСД и Петровскому острову с новыми заведениями",
          "Хорошая транспортная доступность от метро Петроградская"
        ]
      },
      {
        "heading": "Чем отличается от центра",
        "body": "Если центральный район — это витрина Петербурга, то Петроградская сторона — его гостиная. Меньше туристических ловушек, больше мест, где действительно вкусно и по разумной цене. Средний чек здесь ниже, чем на Невском, при сопоставимом качестве кухни. Для жителей района это плюс, для гостей города — повод специально приехать.",
        "highlight": "Если хотите почувствовать настоящий Петербург без туристической суеты — Петроградская сторона идеальна для прогулки и ужина."
      },
      {
        "heading": "Где поесть с особым видом",
        "body": "Панорамных видов на Петроградской стороне меньше, чем в центре, но они есть. Рестораны с видом на Неву и Петропавловскую крепость — особый формат, доступный в нескольких заведениях. Впрочем, если вам важен именно вид — ресторан «Паруса на крыше» (ул. Марата, 5, Olympic Plaza, 6 этаж) расположен в Центральном районе и предлагает 360° панораму исторического центра. Рейтинг 5,0 на Яндекс Картах при 2 606 отзывах подтверждает: это один из лучших выборов для особого ужина.",
        "list": [
          "Рестораны с видом на Неву — редкость, которую ценят",
          "Большинство лучших панорам сосредоточены в Центральном районе",
          "«Паруса на крыше» — 20 минут от Петроградской, вид на весь город"
        ]
      },
      {
        "heading": "Советы по выбору",
        "body": "Для обычного ужина компанией: ищите заведения на Каменноостровском или в переулках вокруг — соотношение цена/качество хорошее. Для особого вечера или банкета: лучше рассмотреть рестораны Центрального района — там больше залов и панорамных опций. Подробнее о выборе ресторана для банкета читайте в нашем <a href='/blog/restorany-privatnym-zalom-spb' class='underline text-accent'>материале о ресторанах с приватным залом</a>."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "restorany-vasilievskiy-ostrov-spb",
    "title": "Рестораны Васильевского острова: где поесть в СПб",
    "metaTitle": "Рестораны Васильевского острова СПб 2026 | Паруса на крыше",
    "metaDescription": "Рестораны Васильевского острова Санкт-Петербурга: обзор лучших мест, кухня, цены. Где вкусно поесть на Васильевском.",
    "keywords": "рестораны васильевский остров, рестораны васильевский остров спб, где поесть васильевский",
    "date": "2026-06-02",
    "category": "Рестораны Петербурга",
    "readTime": 7,
    "image": "/photos/view_day.webp",
    "lead": "Васильевский остров — студенческий и деловой район Петербурга с давними традициями и активно развивающейся ресторанной сценой. Линии Васильевского острова, набережные Невы и современный «Севкабель Порт» создают разнообразный ресторанный ландшафт.",
    "sections": [
      {
        "heading": "Ресторанная карта Васильевского острова",
        "body": "Основные ресторанные кластеры: Большой проспект В. О. (самая насыщенная зона), набережная Лейтенанта Шмидта (виды на Неву и Исаакий), «Севкабель Порт» (молодёжное пространство с едой и видом на залив), 6–7-я линии (кафе и небольшие рестораны). Каждая зона имеет свою публику и ценовую категорию.",
        "list": [
          "Большой проспект В. О. — главная ресторанная улица острова",
          "Набережная Лейтенанта Шмидта — виды на Неву",
          "«Севкабель Порт» — модное пространство с едой летом",
          "Линии В. О. — демократичные кафе для жителей района"
        ]
      },
      {
        "heading": "Особенности выбора",
        "body": "Васильевский — не туристическая зона, хотя рядом Эрмитаж и Кунсткамера. Рестораны ориентированы на местных жителей, студентов и сотрудников офисов. Ценовой диапазон широкий: от бюджетных столовых при университетах до ресторанов со средним чеком 2 000 ₽. Для банкетных мероприятий на 30+ человек на острове вариантов меньше — большинство заведений небольшие."
      },
      {
        "heading": "Когда лучше выбрать другой район",
        "body": "Для панорамного ужина с видом на исторический центр, банкета или особого события — Центральный район предпочтительнее. Ресторан «Паруса на крыше» (ул. Марата, 5) находится в 15 минутах от Васильевского острова и предлагает вид 300° на купола и крыши Петербурга, авторскую кухню и зал до 300 гостей. «Хорошее место 2026» по версии Яндекса. Читайте о <a href='/blog/restorany-tsentralnyy-rayon-spb' class='underline text-accent'>ресторанах Центрального района</a>."
      }
    ],
    "cta": { "text": "Забронировать столик", "href": "/" }
  },
  {
    "slug": "restorany-admiralteyskiy-rayon-spb",
    "title": "Рестораны Адмиралтейского района Петербурга",
    "metaTitle": "Рестораны Адмиралтейского района СПб 2026 | Паруса на крыше",
    "metaDescription": "Лучшие рестораны Адмиралтейского района Санкт-Петербурга: Исаакиевская площадь, набережные, Сенная. Где поесть в центре.",
    "keywords": "рестораны адмиралтейский район, рестораны адмиралтейский район санкт-петербург, рестораны исаакиевская площадь",
    "date": "2026-06-02",
    "category": "Рестораны Петербурга",
    "readTime": 7,
    "image": "/photos/view_day.webp",
    "lead": "Адмиралтейский район — сердце исторического Петербурга. Исаакиевский собор, Дворцовая набережная, набережная Мойки и Фонтанки, Сенная площадь — всё это создаёт уникальный ресторанный контекст. Здесь ищут особой атмосферы, красивых видов и достойной кухни.",
    "sections": [
      {
        "heading": "Ресторанные зоны района",
        "body": "Адмиралтейский район делится на несколько ресторанных кластеров: набережная Мойки и Фонтанки (исторические здания, камерные рестораны), район Сенной площади (демократичный сегмент), улица Декабристов и Лермонтовский проспект (ресторанный кластер для местных), набережная Крюкова канала. Каждая зона имеет свой характер и ценовой уровень.",
        "list": [
          "Набережная Мойки — атмосферные рестораны в исторических зданиях",
          "Сенная площадь — демократичный сегмент с быстрой едой",
          "Улица Декабристов — более спокойный ресторанный квартал",
          "Близость к Мариинскому театру — рестораны для театралов"
        ]
      },
      {
        "heading": "Что важно при выборе",
        "body": "Адмиралтейский район граничит с Центральным — и расстояния здесь небольшие. Если вам нужен панорамный вид на город, лучше выбрать ресторан на возвышении. «Паруса на крыше» (ул. Марата, 5 — это Центральный район, в 10 минутах ходьбы от границы Адмиралтейского) предлагает панораму с 6-го этажа Olympic Plaza. Рейтинг 5,0 и звание «Хорошее место 2026» делают его эталоном для особых поводов."
      },
      {
        "heading": "Для туристов в районе Исаакия",
        "body": "Если вы гуляете по Исаакиевской площади и хотите поесть — вариантов много, но цены в самых туристических местах завышены. Рекомендуем уйти на 2–3 улицы от набережной: там кухня не хуже, а цены реальнее. Для обеда — хорошее решение. Для вечернего ужина с петербургской атмосферой — читайте о <a href='/blog/restorany-vid-neva-peterburg' class='underline text-accent'>ресторанах с видом на Неву</a>."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "restorany-u-moskovskogo-vokzala-spb",
    "title": "Рестораны у Московского вокзала СПб: где поесть",
    "metaTitle": "Рестораны у Московского вокзала СПб 2026 | Паруса на крыше",
    "metaDescription": "Рестораны рядом с Московским вокзалом Санкт-Петербурга: где вкусно поесть до или после поезда. Обзор мест на Невском.",
    "keywords": "рестораны московский вокзал спб, рестораны у московского вокзала петербург, где поесть у вокзала спб",
    "date": "2026-06-02",
    "category": "Рестораны Петербурга",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Московский вокзал — одно из самых людных мест Петербурга. Ежедневно здесь проходят десятки тысяч человек: туристы, командировочные, петербуржцы. Рядом с вокзалом масса заведений — от фастфуда до полноценных ресторанов. Разберёмся, где реально стоит поесть.",
    "sections": [
      {
        "heading": "Рестораны прямо у вокзала",
        "body": "Площадь Восстания и ближайшие улицы — территория туристических заведений с завышенными ценами и средним качеством. Исключения есть, но их нужно искать. Лучшая стратегия: пройти 5–10 минут по Невскому проспекту в сторону Казанского собора — и вы попадёте в зону с реальным выбором и нормальными ценами.",
        "list": [
          "Площадь Восстания — много туристических заведений",
          "Невский в сторону центра — более достойные варианты",
          "Рубинштейна и Марата — лучшие рестораны в 10 минутах ходьбы",
          "Формат зависит от времени: до поезда — быстро, после — можно обстоятельно"
        ]
      },
      {
        "heading": "Если хочется нормального ужина",
        "body": "После долгой дороги в поезде многие хотят сесть за хороший стол с видом. Ресторан «Паруса на крыше» (ул. Марата, 5, 6-й этаж Olympic Plaza) находится в 15 минутах пешком от Московского вокзала. Панорама города, авторская кухня, живая музыка — отличный способ начать или завершить поездку в Петербург. Бизнес-ланч от 590 ₽, ужин — средний чек 1 300 ₽."
      },
      {
        "heading": "Практические советы",
        "body": "Если у вас поезд и мало времени: выбирайте сетевые кафе на Невском — они стабильны по качеству. Если приехали и хотите провести вечер: улица Марата — в 15 минутах ходьбы — один из лучших ресторанных кластеров города. Читайте о <a href='/blog/restorany-ulitsa-marata-spb' class='underline text-accent'>ресторанах на улице Марата</a>."
      }
    ],
    "cta": { "text": "Забронировать стол в «Парусах»", "href": "/" }
  },
  {
    "slug": "restorany-liteynyy-prospekt-spb",
    "title": "Рестораны на Литейном проспекте СПб",
    "metaTitle": "Рестораны на Литейном проспекте СПб 2026 | Паруса на крыше",
    "metaDescription": "Рестораны Литейного проспекта в Санкт-Петербурге: где поесть, атмосфера, кухня. Обзор лучших заведений.",
    "keywords": "рестораны литейный проспект спб, рестораны литейный проспект петербург, кафе литейный спб",
    "date": "2026-06-02",
    "category": "Рестораны Петербурга",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Литейный проспект — один из старейших проспектов Петербурга. Атмосфера здесь принципиально другая, чем на Невском: тише, аутентичнее, больше постоянных гостей. Рестораны Литейного ориентированы на вдумчивый выбор и регулярные визиты.",
    "sections": [
      {
        "heading": "Что представляет собой Литейный",
        "body": "Литейный проспект соединяет Невский с Финляндским вокзалом. Здесь пересекаются несколько ресторанных микрорайонов: улица Жуковского (кафе и небольшие рестораны), Ковенский переулок (тихие места для неспешного обеда), район Некрасовского рынка. Публика — петербуржцы среднего класса, офисные работники, жители соседних домов.",
        "list": [
          "Тихий и нетуристический — здесь едят местные",
          "Уровень кухни стабильный при умеренных ценах",
          "Улица Жуковского — небольшой ресторанный кластер",
          "Легко добраться: метро Маяковская в 5 минутах"
        ]
      },
      {
        "heading": "Для особого вечера — выбирайте с умом",
        "body": "На Литейном нет панорамных ресторанов или банкетных залов. Если вам нужен вид на город, живая музыка или мероприятие на 50+ человек — лучше рассмотреть рестораны ближе к историческому центру. «Паруса на крыше» (ул. Марата, 5 — 5 минут от Литейного) — очевидный выбор для таких случаев: рейтинг 5,0, зал до 300 гостей, банкетное меню от 2 500 ₽/чел. Читайте о <a href='/blog/restorany-privatnym-zalom-spb' class='underline text-accent'>ресторанах с приватным залом</a>."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "restorany-u-isaakievskogo-sobora-spb",
    "title": "Рестораны у Исаакиевского собора в Петербурге",
    "metaTitle": "Рестораны у Исаакиевского собора СПб 2026 | Паруса на крыше",
    "metaDescription": "Рестораны рядом с Исаакиевским собором в Петербурге: где поесть после экскурсии, обзор мест по цене и кухне.",
    "keywords": "рестораны у исаакиевского собора, рестораны исаакиевская площадь петербург, где поесть у исаакия спб",
    "date": "2026-06-02",
    "category": "Рестораны Петербурга",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Исаакиевский собор — одна из главных достопримечательностей Петербурга. После подъёма на колоннаду или осмотра интерьеров хочется хорошо поесть. В ближайших кварталах есть и туристические ловушки, и настоящие хорошие рестораны — важно знать, куда идти.",
    "sections": [
      {
        "heading": "Рестораны прямо у собора",
        "body": "На Исаакиевской площади и Почтамтской улице сосредоточены преимущественно туристические кафе и рестораны с завышенными ценами на фоне вида. Качество еды в них нередко уступает цене. Рекомендуем пройти 5–7 минут: набережная Мойки, Большая Морская, Конногвардейский бульвар предлагают лучшее соотношение цена/вид/кухня.",
        "list": [
          "Исаакиевская площадь — туристический сегмент с наценкой за вид",
          "Набережная Мойки — более разумный выбор в 5 минутах",
          "Большая Морская — камерные рестораны для ценителей",
          "Конногвардейский бульвар — уютные кафе"
        ]
      },
      {
        "heading": "Ресторан с видом на купол — альтернативный вариант",
        "body": "Интересная опция: вместо ресторана прямо у Исаакия — ресторан с видом на него. «Паруса на крыше» (ул. Марата, 5, 6 этаж) находится в 15 минутах ходьбы. С высоты открывается вид на купол Исаакиевского собора, Казанский собор, крыши центра — всё вместе как одна большая открытка. Рейтинг 5,0 на Яндекс Картах, авторская кухня, бизнес-ланч от 590 ₽. Читайте о <a href='/blog/restoran-s-vidom-na-kazanskiy-sobor' class='underline text-accent'>ресторанах с видом на соборы</a>."
      }
    ],
    "cta": { "text": "Забронировать стол с видом на город", "href": "/" }
  },
  {
    "slug": "restorany-zagorodnyy-prospekt-peterburg",
    "title": "Рестораны на Загородном проспекте Петербурга",
    "metaTitle": "Рестораны Загородный проспект Петербург 2026 | Паруса на крыше",
    "metaDescription": "Рестораны на Загородном проспекте Санкт-Петербурга: обзор лучших заведений, кухня, цены и атмосфера.",
    "keywords": "рестораны загородный проспект петербург, рестораны загородный проспект спб, кафе загородный",
    "date": "2026-06-02",
    "category": "Рестораны Петербурга",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Загородный проспект — один из самых «петербургских» проспектов центральной части города. Здесь мало туристов, зато много местных жителей и отличных ресторанов, которые работают годами. Улица Марата, которая пересекает Загородный — отдельная история.",
    "sections": [
      {
        "heading": "Ресторанный квартал Загородного",
        "body": "Загородный проспект от Пяти углов до Витебского вокзала — одна из самых концентрированных ресторанных зон нетуристического Петербурга. Здесь работают заведения разных форматов: грузинская кухня, японские суши, европейские бистро, русские трактиры. Публика — жители Центрального района, студенты Технологического института, офисные работники.",
        "list": [
          "От Пяти углов до Витебского вокзала — плотная ресторанная зона",
          "Разнообразная кухня: от грузинской до европейской",
          "Цены ниже, чем на Невском, при хорошем качестве",
          "Пересечение с улицей Марата — двойная концентрация мест"
        ]
      },
      {
        "heading": "Улица Марата как продолжение Загородного",
        "body": "Улица Марата пересекает Загородный проспект — и именно здесь находится ресторан «Паруса на крыше» (дом 5, Olympic Plaza, 6 этаж). Это самый известный ресторан этого квартала: рейтинг 5,0, 2 606 отзывов, «Хорошее место 2026». Если вы гуляете по Загородному и хотите ужин с видом на город — поднимитесь на 6-й этаж. Читайте о <a href='/blog/restorany-ulitsa-marata-spb' class='underline text-accent'>ресторанах улицы Марата</a>."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "restorany-u-fontanki-peterburg",
    "title": "Рестораны у Фонтанки в Петербурге: лучшие места",
    "metaTitle": "Рестораны у Фонтанки Петербург 2026 | Паруса на крыше",
    "metaDescription": "Рестораны на набережной Фонтанки в Санкт-Петербурге: где поесть с видом на канал, обзор заведений по кухне.",
    "keywords": "рестораны набережная фонтанки, рестораны у фонтанки петербург, кафе фонтанка спб",
    "date": "2026-06-02",
    "category": "Рестораны Петербурга",
    "readTime": 7,
    "image": "/photos/view_day.webp",
    "lead": "Набережная реки Фонтанки — одна из самых протяжённых и разнообразных набережных Петербурга. От Летнего сада до Обводного канала она проходит через несколько районов и ресторанных кластеров. Вид на воду здесь другой, чем на Неве — камерный, уютный.",
    "sections": [
      {
        "heading": "Фонтанка от Летнего сада до Обводного",
        "body": "Верхний участок Фонтанки (Летний сад — Аничков мост) — самый туристический: много кафе, средний уровень кухни, высокие цены за вид на воду. Средняя Фонтанка (Аничков — Обводный) постепенно джентрифицируется: появляются интересные заведения с аутентичной кухней. На самой набережной рестораны работают в исторических зданиях с окнами на канал — это особая атмосфера.",
        "list": [
          "Летний сад — Аничков мост: туристический сегмент",
          "Ниже Аничкова: более интересные и доступные заведения",
          "Вид на канал создаёт особую, тихую петербургскую атмосферу",
          "Некоторые рестораны организуют столики прямо у воды летом"
        ]
      },
      {
        "heading": "Вид снизу vs вид сверху",
        "body": "Сидеть у воды и смотреть на Фонтанку — одно удовольствие. Смотреть с высоты на всё это сверху — другое. «Паруса на крыше» (ул. Марата, 5, 10 минут от Фонтанки) предлагает именно второй вариант: панорама с 6-го этажа включает крыши, купола и всю архитектуру центра. Рейтинг 5,0, бизнес-ланч от 590 ₽. Для особого ужина — достойная альтернатива набережной.",
        "highlight": "Летом рестораны у Фонтанки открывают веранды — бронируйте заранее, места разбирают быстро."
      },
      {
        "heading": "Практические советы",
        "body": "Для прогулки с перекусом вдоль Фонтанки — хватит стрит-фуда и кофеен. Для полноценного обеда или ужина — выбирайте рестораны в переулках, а не прямо на набережной: там качество выше при тех же ценах. Подробнее о рестораны с видом — в нашем <a href='/blog/restorany-vid-neva-peterburg' class='underline text-accent'>обзоре видовых ресторанов</a>."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "restorany-u-dvortsovoy-ploshchadi-spb",
    "title": "Рестораны у Дворцовой площади СПб: где поесть",
    "metaTitle": "Рестораны у Дворцовой площади СПб 2026 | Паруса на крыше",
    "metaDescription": "Рестораны рядом с Дворцовой площадью в Санкт-Петербурге: обзор лучших мест после Эрмитажа, цены и кухня.",
    "keywords": "рестораны дворцовая площадь спб, где поесть у дворцовой площади, рестораны после эрмитажа",
    "date": "2026-06-02",
    "category": "Рестораны Петербурга",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Дворцовая площадь — главная площадь России. После прогулки по Эрмитажу или просто после долгой прогулки вдоль Невы сюда приходят тысячи людей. Где поесть в этом самом туристическом месте города — и можно ли найти хорошее заведение без туристической наценки?",
    "sections": [
      {
        "heading": "Ресторанная зона у Эрмитажа",
        "body": "Дворцовая площадь и прилегающие улицы — Миллионная, Большая Морская, Адмиралтейский проспект — наиболее туристическая ресторанная зона. Цены здесь выше средних по городу, меню часто переведены на 10 языков, а качество кухни не всегда соответствует ценнику. Настоящие рестораны с хорошей кухней и справедливыми ценами нужно искать чуть дальше.",
        "list": [
          "Миллионная и Большая Морская — рядом с Эрмитажем, высокие цены",
          "Конюшенная площадь — чуть демократичнее",
          "Невский проспект от Адмиралтейства — разнообразный выбор",
          "Лучшие рестораны в 10–15 минутах ходьбы от площади"
        ]
      },
      {
        "heading": "Альтернатива: поднимитесь над городом",
        "body": "После Эрмитажа петербургские виды ещё не заканчиваются — они продолжаются в «Парусах на крыше» (ул. Марата, 5, 6 этаж, 20 минут пешком или 5 минут на такси). Смотровая панорама 300° на купола, крыши и закат над городом. Авторская кухня, живая музыка, рейтинг 5,0. Идеальное завершение дня в Петербурге. О ресторанах после Эрмитажа — читайте <a href='/blog/gde-poyest-posle-ermitazha-spb' class='underline text-accent'>наш материал</a>."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "restorany-vid-kupolov-spb",
    "title": "Рестораны с видом на купола Петербурга: топ мест",
    "metaTitle": "Рестораны с видом на купола СПб 2026 | Паруса на крыше",
    "metaDescription": "Рестораны с видом на купола Санкт-Петербурга: Казанский, Исаакиевский, Смольный. Где увидеть лучшую панораму за ужином.",
    "keywords": "рестораны вид купола петербург, рестораны с видом на купола спб, панорамный ресторан купола петербург",
    "date": "2026-06-02",
    "category": "Рестораны Петербурга",
    "readTime": 7,
    "image": "/photos/view_sunset.webp",
    "lead": "Купола соборов — визитная карточка Петербурга. Казанский, Исаакиевский, Смольный, Владимирский — каждый по-своему прекрасен. Но по-настоящему оценить панораму куполов можно только с высоты. Рестораны, откуда виден этот силуэт — особый жанр петербургской гастрономии.",
    "sections": [
      {
        "heading": "Какие купола видно с разных точек",
        "body": "Петербург построен горизонтально — высоких зданий мало, зато купола соборов возвышаются над общей линией крыш. С 5–7 этажа открывается уникальный вид: не фасады домов, а именно купола и шпили на фоне неба. Казанский собор виден из Центрального района, Исаакиевский — с юга, Смольный — с востока. Лучшая точка для охвата сразу нескольких куполов — район улицы Марата.",
        "list": [
          "Казанский собор — виден из Центрального района",
          "Исаакиевский — доминирует в западной части центра",
          "Смольный собор — виден с правого берега Невы",
          "Владимирский собор — рядом с Пяти углами"
        ]
      },
      {
        "heading": "«Паруса на крыше» — ресторан с видом на Казанский",
        "body": "Ресторан «Паруса на крыше» (ул. Марата, 5, 6-й этаж Olympic Plaza) расположен так, что из его панорамных окон открывается вид прямо на купол Казанского собора. Это особый эстетический опыт: вы за ужином, а за окном — одна из лучших сакральных архитектурных доминант города. Рейтинг 5,0 на Яндекс Картах, «Хорошее место 2026».",
        "highlight": "Вечером, когда собор подсвечен, вид становится особенно впечатляющим. Самое красивое время для ужина — закат и сумерки."
      },
      {
        "heading": "Другие смотровые точки с едой",
        "body": "Несколько ресторанов в центре предлагают виды на отдельные соборы, но полноценная панорама с несколькими доминантами в одном кадре — редкость. Именно поэтому «Паруса» с их 300° видом стали эталоном: здесь виден и Казанский, и крыши Центрального района, и горизонт. Читайте о <a href='/blog/restoran-s-vidom-na-kazanskiy-sobor' class='underline text-accent'>ресторанах с видом на Казанский собор</a>."
      }
    ],
    "cta": { "text": "Забронировать стол с видом на купола", "href": "/" }
  },
  {
    "slug": "luchshie-kryshi-peterburg-gde-poest",
    "title": "Лучшие крыши Петербурга: где поесть с высоты",
    "metaTitle": "Лучшие крыши Петербурга — рестораны и виды 2026 | Паруса на крыше",
    "metaDescription": "Где поесть на крыше в Петербурге: топ ресторанов на высоте, виды, цены. Обзор лучших мест с панорамой города.",
    "keywords": "лучшие крыши петербурга где поесть, рестораны на крыше петербург топ, крыша ресторан спб",
    "date": "2026-06-02",
    "category": "Рестораны Петербурга",
    "readTime": 8,
    "image": "/photos/view_clouds.webp",
    "lead": "«Крыши Петербурга» — это целый культ. Но если экскурсионные крыши предлагают только вид, то рестораны на крышах дают ещё и гастрономический опыт. Разберём, что значит «лучшая крыша» для тех, кто хочет поесть — не просто постоять и сфотографироваться.",
    "sections": [
      {
        "heading": "Форматы «крыш» в Петербурге",
        "body": "В городе существует несколько типов заведений с «крышей» в названии или концепции: экскурсионные крыши без еды, летние бары на кровлях (сезонные, ограниченное меню), рестораны на верхних этажах с панорамными окнами (работают круглый год). Для гастрономического опыта актуален только третий тип — полноценный ресторан с кухней и сервисом, но с видом сверху.",
        "list": [
          "Экскурсионные крыши — только вид, без еды",
          "Летние бары на кровлях — сезонно, ограниченный выбор блюд",
          "Рестораны на верхних этажах — круглогодично, полный сервис",
          "Лучший вариант для ужина — именно третий тип"
        ]
      },
      {
        "heading": "«Паруса на крыше» — стандарт жанра",
        "body": "Ресторан «Паруса на крыше» (ул. Марата, 5, Olympic Plaza, 6-й этаж) существует с 2009 года и давно стал точкой отсчёта для разговора о ресторанах «на высоте» в Петербурге. 300° панорама исторического центра, авторская кухня, банкетный зал до 300 гостей, живая музыка. Рейтинг 5,0 на Яндекс Картах при 2 606 отзывах. «Хорошее место 2026».",
        "highlight": "Открытая терраса работает в тёплое время года — летом бронировать нужно за 2–3 недели, места разбирают быстро."
      },
      {
        "heading": "На что смотреть при выборе",
        "body": "Ключевые вопросы: работает ли ресторан зимой или только летом? Реальный ли вид или «частичный»? Есть ли полноценная кухня? Можно ли провести банкет? В «Парусах» ответы на все эти вопросы положительные. Читайте о <a href='/blog/restorany-vid-kryshi-peterburg' class='underline text-accent'>ресторанах с видом на крыши Петербурга</a>."
      }
    ],
    "cta": { "text": "Забронировать стол с видом на город", "href": "/" }
  },
  {
    "slug": "otkrytye-restorany-vid-gorod-spb",
    "title": "Открытые рестораны с видом на город в СПб",
    "metaTitle": "Открытые рестораны с видом на город СПб 2026 | Паруса на крыше",
    "metaDescription": "Открытые рестораны и веранды с видом на Петербург: топ мест для летнего ужина под открытым небом.",
    "keywords": "открытые рестораны вид город спб, рестораны веранда вид петербург, летние рестораны вид спб",
    "date": "2026-06-02",
    "category": "Рестораны Петербурга",
    "readTime": 7,
    "image": "/photos/terrace.webp",
    "lead": "Летом в Петербурге хочется есть под открытым небом. Открытые веранды и террасы с видом на город — лучшее, что может предложить петербургская ресторанная сцена в белые ночи. Разбираем, где найти идеальное сочетание свежего воздуха, кухни и панорамы.",
    "sections": [
      {
        "heading": "Почему летние рестораны в Петербурге особенные",
        "body": "Белые ночи — уникальное явление. Ужин в 22:00 при естественном свете, тёплый ветер, виды на Неву и небо, которое не темнеет — это нельзя повторить нигде в мире. Петербургские рестораны с открытыми террасами используют этот ресурс по максимуму: летние веранды открываются в мае и работают до сентября.",
        "list": [
          "Белые ночи (июнь–июль) — пик сезона открытых террас",
          "Виды на Неву, крыши, каналы — разные форматы открытых ресторанов",
          "Бронировать летние веранды нужно за 1–2 недели",
          "Июнь–август — самые востребованные даты"
        ]
      },
      {
        "heading": "Терраса «Парусов» — над городом",
        "body": "Терраса ресторана «Паруса на крыше» (ул. Марата, 5, 6 этаж) в тёплое время года открывает прямой выход на кровлю. Ужин на высоте 6-го этажа с видом на исторический центр в белые ночи — это то, ради чего стоит специально ехать в Петербург. Рейтинг 5,0, живая музыка, авторская кухня.",
        "highlight": "В период белых ночей (примерно с 25 мая по 15 июля) на открытой террасе «Парусов» особенно красиво: ночь не наступает, небо остаётся светлым до рассвета."
      },
      {
        "heading": "Советы по планированию летнего ужина",
        "body": "Лучшее время для открытой веранды: 20:00–23:00 — солнце низко, свет тёплый, воздух освежает. Резервируйте столик заранее: в июне все лучшие летние рестораны заняты на недели вперёд. О летних ресторанах Петербурга — читайте в <a href='/blog/letnie-restorany-terrasa-spb' class='underline text-accent'>нашем обзоре</a>."
      }
    ],
    "cta": { "text": "Забронировать столик на террасе", "href": "/terrasa" }
  },
  {
    "slug": "restorany-na-vysote-peterburg",
    "title": "Рестораны на высоте в Петербурге: где поесть с панорамой",
    "metaTitle": "Рестораны на высоте в Петербурге 2026 | Паруса на крыше",
    "metaDescription": "Рестораны на высоте в Санкт-Петербурге: обзор заведений на верхних этажах с панорамным видом на город.",
    "keywords": "рестораны на высоте петербург, рестораны верхние этажи спб, панорамные рестораны высота петербург",
    "date": "2026-06-02",
    "category": "Рестораны Петербурга",
    "readTime": 7,
    "image": "/photos/view_sunset.webp",
    "lead": "Петербург — горизонтальный город: исторический центр застроен зданиями высотой 4–6 этажей. Это значит, что любой ресторан на 5–6 этаже уже предлагает панорамный вид, непохожий на то, что видно с улицы. Рестораны «на высоте» в Петербурге — особый формат с особой атмосферой.",
    "sections": [
      {
        "heading": "Почему «высота» в Петербурге — это всего 5–6 этажей",
        "body": "В Москве панорамный ресторан — это небоскрёб. В Петербурге достаточно 5–6 этажа: исторический регламент застройки сохранён, и с такой высоты открывается вид не на другие высотки, а на море крыш, куполов и шпилей. Это принципиально другой визуальный опыт — более камерный, но не менее впечатляющий.",
        "list": [
          "Петербург застроен однородно — 5–6 этажей дают реальную панораму",
          "Вид — на крыши, купола и горизонт, а не на бетонные стены",
          "Закон о высотности сохраняет уникальный силуэт города",
          "Несколько ресторанов используют это как конкурентное преимущество"
        ]
      },
      {
        "heading": "«Паруса на крыше» — эталон жанра",
        "body": "Ресторан открылся в 2009 году в Olympic Plaza (ул. Марата, 5) — одном из немногих зданий Центрального района с коммерческими площадями на 6-м этаже. За 15+ лет работы он стал стандартом «ресторана на высоте» в Петербурге: 2 606 отзывов, рейтинг 5,0, «Хорошее место 2026». Авторская кухня, живая музыка, банкет до 300 гостей.",
        "highlight": "Средний чек в «Парусах» — около 1 300 ₽/человек. Бизнес-ланч от 590 ₽ — лучшая цена за такой вид в центре города."
      },
      {
        "heading": "Другие рестораны на высоте в Петербурге",
        "body": "Несколько заведений в городе работают на верхних этажах, но стабильно высокий рейтинг при таком количестве отзывов — редкость. «Паруса» держат планку более 15 лет: это показатель не везения, а системной работы. Для сравнения — читайте о <a href='/blog/panoramnye-restorany-spb' class='underline text-accent'>панорамных ресторанах СПб</a>."
      }
    ],
    "cta": { "text": "Забронировать стол с панорамой", "href": "/" }
  },
  {
    "slug": "restorany-panoramnye-okna-spb",
    "title": "Рестораны с панорамными окнами в Петербурге",
    "metaTitle": "Рестораны с панорамными окнами СПб 2026 | Паруса на крыше",
    "metaDescription": "Рестораны с панорамными окнами в Санкт-Петербурге: большие окна с видом на город, обзор лучших мест.",
    "keywords": "рестораны панорамные окна спб, рестораны большие окна петербург, рестораны с видом через окна спб",
    "date": "2026-06-02",
    "category": "Рестораны Петербурга",
    "readTime": 7,
    "image": "/photos/interior.webp",
    "lead": "Большое окно с видом на Петербург — это произведение искусства, которое меняется каждый час. Утренний туман над крышами, дневное солнце на куполах, закатное золото над горизонтом, ночная подсветка соборов — рестораны с панорамными окнами превращают это в часть гастрономического опыта.",
    "sections": [
      {
        "heading": "Почему окно важно в ресторане",
        "body": "Психологически доказано: виды на природу и открытые пространства снижают тревожность и повышают удовольствие от еды. Ресторан с большими панорамными окнами создаёт ощущение простора и эксклюзивности одновременно. В Петербурге, где здания плотно стоят друг к другу и вид из обычного окна — это кирпичная стена соседнего дома, панорамный ресторан на высоте — редкость.",
        "list": [
          "Вид из окна — часть гастрономического впечатления",
          "Петербургский силуэт особенно красив в золотой час",
          "Хорошее освещение в панорамных ресторанах — от природного света",
          "Фотографии из-за столика с видом — моментальные"
        ]
      },
      {
        "heading": "«Паруса на крыше» — 300° панорамы",
        "body": "Зал ресторана «Паруса на крыше» (ул. Марата, 5, 6 этаж) спроектирован с максимальным остеклением. Три стороны зала — это фактически сплошное панорамное окно, с видом на Казанский собор, крыши Центрального района и горизонт. Даже в пасмурный день виды сохраняют магию — Петербург красив при любой погоде.",
        "highlight": "Лучший столик для вида — у окна с видом на запад: именно там закат. Просите при бронировании заранее."
      },
      {
        "heading": "Как выбрать время для максимального впечатления",
        "body": "Золотой час (за час до заката) — лучшее время для романтического ужина с видом. Белые ночи (июнь–июль) — вечер остаётся светлым до полуночи. Зима — особая магия подсвеченного снежного Петербурга. Об ужине в разные сезоны читайте в <a href='/blog/restorany-belie-nochi-spb' class='underline text-accent'>статье о белых ночах</a>."
      }
    ],
    "cta": { "text": "Забронировать стол у окна", "href": "/" }
  },
  {
    "slug": "vidovye-restorany-peterburg",
    "title": "Видовые рестораны Петербурга: где лучший вид",
    "metaTitle": "Видовые рестораны Петербурга 2026 — где лучший вид | Паруса на крыше",
    "metaDescription": "Видовые рестораны Санкт-Петербурга: рейтинг лучших мест с панорамой на город, реки и соборы. Обзор 2026.",
    "keywords": "видовые рестораны петербург, рестораны с лучшим видом спб, панорама ресторан петербург",
    "date": "2026-06-02",
    "category": "Рестораны Петербурга",
    "readTime": 8,
    "image": "/photos/view_sunset.webp",
    "lead": "«Видовой ресторан» — в Петербурге это отдельный жанр. Город такой красивый, что вид сам по себе является ценностью, за которую готовы платить. Разберём, что делает вид «лучшим» и где его найти.",
    "sections": [
      {
        "heading": "Что значит «лучший вид»",
        "body": "Лучший вид — это не просто «высоко». Это сочетание нескольких факторов: архитектурные доминанты в кадре, широкий угол обзора, правильная ориентация (на запад для заката), отсутствие новостроек и рекламных щитов, смена освещения в течение дня. В Петербурге это особенно важно: исторический центр охраняется законом о высотности, поэтому правильно расположенный ресторан на 5–6 этаже даёт видовой ряд без конкурентов.",
        "list": [
          "Архитектурные доминанты: купола, шпили, набережные",
          "Широкий угол обзора: не одна точка, а панорама",
          "Запад — направление для закатных видов",
          "Отсутствие высотных помех: работает только в историческом центре"
        ]
      },
      {
        "heading": "Рейтинг видовых ресторанов",
        "body": "По совокупности факторов — ширина обзора, архитектурный контекст, качество кухни и стабильность работы — ресторан «Паруса на крыше» (ул. Марата, 5) занимает особое место. 15 лет работы, рейтинг 5,0 при 2 606 отзывах, «Хорошее место 2026» — это не маркетинг, а подтверждённая гостями репутация.",
        "highlight": "Рейтинг 5,0 при более чем 2 000 отзывах — статистически редкое явление. Это означает, что абсолютное большинство гостей ставят пять звёзд."
      },
      {
        "heading": "Как выбрать видовой ресторан",
        "body": "Совет: перед бронированием посмотрите реальные фото из зала в отзывах, не только профессиональные фотографии на сайте. Реальный вид может сильно отличаться. У «Парусов» более 2 600 отзывов с фото — вы точно знаете, что увидите. Подробнее читайте о <a href='/blog/restorany-vid-kryshi-peterburg' class='underline text-accent'>ресторанах с видом на крыши</a>."
      }
    ],
    "cta": { "text": "Забронировать стол с лучшим видом", "href": "/" }
  },
  {
    "slug": "restorany-vid-petropavlovskaya-spb",
    "title": "Рестораны с видом на Петропавловскую крепость СПб",
    "metaTitle": "Рестораны с видом на Петропавловскую крепость СПб | Паруса на крыше",
    "metaDescription": "Рестораны с видом на Петропавловскую крепость в Петербурге: где поесть с красивым видом на крепость и Неву.",
    "keywords": "рестораны вид петропавловская крепость, рестораны петропавловская крепость петербург, ресторан вид крепость спб",
    "date": "2026-06-02",
    "category": "Рестораны Петербурга",
    "readTime": 7,
    "image": "/photos/view_day.webp",
    "lead": "Петропавловская крепость с её золотым шпилем — один из главных символов Петербурга. Вид на неё с другого берега Невы или с высоты стал самой узнаваемой петербургской открыткой. Несколько ресторанов предлагают этот вид за ужином — разберём варианты.",
    "sections": [
      {
        "heading": "С каких точек видна крепость",
        "body": "Петропавловскую крепость расположена на Заячьем острове. Лучший вид на неё — с Дворцовой набережной, с Биржевого моста, с Стрелки Васильевского острова. Рестораны с видом на крепость — это преимущественно заведения на Петроградской стороне, набережной Невы и Стрелке. Однако многие из них — сезонные или небольшие.",
        "list": [
          "Дворцовая набережная — прямой вид на шпиль крепости",
          "Биржевой мост и Стрелка В. О. — классический открыточный вид",
          "Петроградская сторона — рестораны у воды с видом на крепость",
          "Часть заведений работает только летом"
        ]
      },
      {
        "heading": "Альтернатива: вид на весь город сразу",
        "body": "Если крепость как отдельная точка — это красиво, то весь силуэт Петербурга разом — это ошеломляюще. «Паруса на крыше» (ул. Марата, 5, 6 этаж) открывают 300° панораму: и крепость видна, и Казанский собор, и крыши центра. Для тех, кто хочет «всё и сразу» — лучший выбор. Рейтинг 5,0, авторская кухня, круглый год. О панорамных ресторанах — читайте <a href='/blog/panoramnye-restorany-spb' class='underline text-accent'>наш обзор</a>."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "restorany-krasivyy-vid-uzhin-spb",
    "title": "Рестораны с красивым видом для ужина в СПб: топ",
    "metaTitle": "Рестораны с красивым видом для ужина СПб 2026 | Паруса на крыше",
    "metaDescription": "Лучшие рестораны с красивым видом для романтического или особого ужина в Санкт-Петербурге. Рейтинг 2026.",
    "keywords": "рестораны красивый вид ужин спб, ресторан с видом для ужина петербург, красивый ужин с видом спб",
    "date": "2026-06-02",
    "category": "Рестораны Петербурга",
    "readTime": 8,
    "image": "/photos/view_sunset.webp",
    "lead": "Ужин с красивым видом — это особый формат вечера. Не просто поесть, а получить визуальное и гастрономическое удовольствие одновременно. В Петербурге такие места есть — но их значительно меньше, чем кажется, если задуматься о качестве и вида, и кухни.",
    "sections": [
      {
        "heading": "Что делает ужин с видом особенным",
        "body": "Три компонента идеального «ужина с видом»: сам вид (широкий, архитектурно богатый, меняющийся с освещением), качество кухни (авторская или как минимум профессиональная), атмосфера (свет, музыка, сервис). Если одна составляющая слабая — впечатление разрушается. Петербургский ресторан, который держит все три на высоком уровне годами, — редкость.",
        "list": [
          "Вид: широкий, с архитектурными доминантами",
          "Кухня: авторская, с живыми вкусами",
          "Атмосфера: свет, музыка, ненавязчивый сервис",
          "Всё три вместе — редкое сочетание"
        ]
      },
      {
        "heading": "«Паруса на крыше»: 15 лет сочетают все три",
        "body": "Ресторан работает с 2009 года (ул. Марата, 5, Olympic Plaza, 6 этаж). За это время сложилась репутация: 2 606 отзывов, рейтинг 5,0 на Яндекс Картах, «Хорошее место 2026». Авторская кухня, живая музыка по расписанию, банкетный зал до 300 гостей, средний чек 1 300 ₽, скидка 20% именинникам.",
        "highlight": "Скидка 20% на счёт именинника действует в течение 7 дней до и после дня рождения. Оплата наличными."
      },
      {
        "heading": "Как спланировать ужин с видом",
        "body": "Резервируйте стол заранее (особенно в пятницу и субботу — за 3–7 дней). Просите столик у окна. Приходите до заката — лучший вид именно в золотой час. Читайте о <a href='/blog/romanticheskiy-uzhin-na-kryshe-peterburga' class='underline text-accent'>романтическом ужине на крыше</a>."
      }
    ],
    "cta": { "text": "Забронировать ужин с видом", "href": "/" }
  },
  {
    "slug": "restoran-6-etazh-panorama-peterburg",
    "title": "Ресторан на 6-м этаже с панорамой Петербурга",
    "metaTitle": "Ресторан на 6-м этаже с панорамой Петербурга | Паруса на крыше",
    "metaDescription": "Ресторан «Паруса на крыше» на 6-м этаже Olympic Plaza в центре Петербурга. Панорама 300°, авторская кухня, бронирование.",
    "keywords": "ресторан 6 этаж петербург, ресторан панорама олимпик плаза, паруса на крыше 6 этаж",
    "date": "2026-06-02",
    "category": "Рестораны Петербурга",
    "readTime": 7,
    "image": "/photos/view_sunset.webp",
    "lead": "Ресторан «Паруса на крыше» занимает 6-й этаж бизнес-центра Olympic Plaza на улице Марата, 5 в Центральном районе Санкт-Петербурга. С этой высоты открывается 300° панорама исторического центра: купол Казанского собора, крыши Центрального района, горизонт над Невой.",
    "sections": [
      {
        "heading": "О ресторане",
        "body": "«Паруса на крыше» работают с 2009 года — это один из старейших панорамных ресторанов Петербурга. За 15+ лет ресторан собрал 2 606 отзывов на Яндекс Картах с рейтингом 5,0 — редкий результат для заведения такого масштаба. В 2026 году получил звание «Хорошее место» от Яндекса.",
        "list": [
          "Адрес: ул. Марата, 5, Olympic Plaza, 6-й этаж",
          "Телефон: +7 (812) 991-10-90",
          "Работает с 2009 года",
          "Вместимость: до 300 гостей"
        ]
      },
      {
        "heading": "Что предлагает ресторан",
        "body": "Авторская кухня с акцентом на морепродукты и мясо на хоспере. Бизнес-ланч в будни от 590 ₽ — лучшее соотношение цена/вид в центре города. Средний чек за ужин — около 1 300 ₽/человек. Банкетное меню от 2 500 ₽/чел для корпоративов и торжеств. Скидка 20% для именинников в течение 7 дней до и после дня рождения.",
        "highlight": "Бизнес-ланч «Парусов» — один из самых популярных в центре: за 590 ₽ вы получаете полноценный обед с видом на панораму города."
      },
      {
        "heading": "Как добраться",
        "body": "Ближайшее метро — Владимирская (5 минут пешком) или Маяковская (10 минут). Парковка доступна в Olympic Plaza. Ресторан находится строго в центре: от Невского проспекта — 10 минут пешком, от Московского вокзала — 15 минут. Подробнее о том, <a href='/blog/kak-doekhat-olimpik-plaza-peterburg' class='underline text-accent'>как добраться до Olympic Plaza</a>."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "restorany-evropeyskoy-kukhni-spb",
    "title": "Рестораны европейской кухни в Петербурге: топ мест",
    "metaTitle": "Рестораны европейской кухни СПб 2026 | Паруса на крыше",
    "metaDescription": "Лучшие рестораны европейской кухни в Санкт-Петербурге: обзор мест по стилю, цене и атмосфере.",
    "keywords": "рестораны европейская кухня спб, рестораны европейская кухня петербург, европейская кухня ресторан спб",
    "date": "2026-06-02",
    "category": "Рестораны Петербурга",
    "readTime": 7,
    "image": "/photos/food.webp",
    "lead": "«Европейская кухня» — широкое понятие, которое объединяет кулинарные традиции Франции, Италии, Испании, Германии и других стран. В Петербурге это самый популярный ресторанный жанр. Разберёмся, что искать.",
    "sections": [
      {
        "heading": "Что входит в понятие «европейская кухня»",
        "body": "В ресторанном контексте «европейская кухня» обычно означает: классические соусы и техники французской школы, итальянские паста и ризотто, испанские морепродукты, австрийские и немецкие мясные блюда. Авторская европейская кухня добавляет к этому локальные продукты — северо-западная рыба, фермерское мясо, сезонные овощи.",
        "list": [
          "Французские техники: соусы, конфи, терриены",
          "Итальянская школа: паста, ризотто, антипасти",
          "Испанские акценты: морепродукты, хамон",
          "Авторская интерпретация с локальными продуктами"
        ]
      },
      {
        "heading": "«Паруса на крыше» — авторская европейская кухня",
        "body": "Ресторан «Паруса на крыше» работает в жанре авторской европейской кухни с акцентом на качестве продукта. Мясо готовится на хоспере — испанском угольном гриле. Морепродукты — свежие, с акцентом на гребешки и рыбу. Карпаччо, ризотто, авторские десерты — всё это часть меню, которое обновляется сезонно. Рейтинг 5,0 на Яндекс Картах.",
        "highlight": "Хоспер — угольный гриль, который даёт мясу особый вкус, недостижимый на обычном гриле или сковороде. Это испанская технология, которую в Петербурге используют редко."
      },
      {
        "heading": "Как выбрать европейский ресторан",
        "body": "Важные критерии: меняется ли меню сезонно (признак работы с живыми продуктами), есть ли авторские позиции (не просто «паста болоньезе»), соответствует ли цена уровню кухни. У «Парусов» — авторское меню, сезонные обновления, средний чек 1 300 ₽. Подробнее о кухне — в нашем <a href='/blog/avtorskaya-kukhnya-peterburg-trendy' class='underline text-accent'>материале об авторской кухне</a>."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "italyanskie-restorany-peterburg-top",
    "title": "Итальянские рестораны Петербурга: топ лучших мест",
    "metaTitle": "Итальянские рестораны Петербурга топ 2026 | Паруса на крыше",
    "metaDescription": "Лучшие итальянские рестораны Санкт-Петербурга: паста, пицца, ризотто. Рейтинг и обзор мест по цене и кухне.",
    "keywords": "итальянские рестораны петербург, итальянские рестораны спб топ, пицца паста ресторан петербург",
    "date": "2026-06-02",
    "category": "Рестораны Петербурга",
    "readTime": 7,
    "image": "/photos/food.webp",
    "lead": "Итальянская кухня — самая популярная иностранная кухня в России. Паста, пицца, ризотто, тирамису — всё это давно стало частью петербургского меню. Но качество итальянских ресторанов очень разное: от аутентичного до «пицца-суши-роллы под одной крышей».",
    "sections": [
      {
        "heading": "Форматы итальянских ресторанов",
        "body": "Аутентичные итальянские рестораны с шефом из Италии — единицы и стоят дорого. Адаптированная итальянская кухня «по-петербургски» — самый распространённый формат: хорошие продукты, знакомые блюда, разумная цена. Авторская итальянская кухня — самое интересное: итальянские техники плюс местные продукты, фантазия шефа.",
        "list": [
          "Аутентичные: дорого, но максимально близко к оригиналу",
          "Адаптированные: доступно, узнаваемо, стабильно",
          "Авторские: итальянская база + петербургская фантазия",
          "Смешанные: «итальянско-японские» — осторожно"
        ]
      },
      {
        "heading": "Элементы итальянской кухни в «Парусах»",
        "body": "В меню ресторана «Паруса на крыше» есть итальянские по технике блюда: карпаччо из говядины, паста, ризотто, авторские десерты по итальянским рецептам. Всё это — в сочетании с панорамой Петербурга и живой музыкой. Итальянская кухня здесь — часть авторского меню, а не самоцель. Средний чек 1 300 ₽, бизнес-ланч от 590 ₽."
      },
      {
        "heading": "На что обращать внимание",
        "body": "При выборе итальянского ресторана: есть ли паста ручной работы или из пачки, свежие ли ингредиенты, обновляется ли меню сезонно. Лучшие итальянские рестораны Петербурга обычно небольшие — 30–60 мест. Для банкета или мероприятия — читайте о <a href='/blog/restorany-bolshoy-kompaniy-peterburg' class='underline text-accent'>ресторанах для большой компании</a>."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "restorany-s-khosperom-spb",
    "title": "Рестораны с хоспером в СПб: где жарят мясо на углях",
    "metaTitle": "Рестораны с хоспером СПб 2026 | Паруса на крыше",
    "metaDescription": "Рестораны с хоспером в Санкт-Петербурге: где мясо готовят на угольном гриле. Обзор лучших мест.",
    "keywords": "рестораны хоспер спб, ресторан хоспер петербург, мясо на углях ресторан спб",
    "date": "2026-06-02",
    "category": "Рестораны Петербурга",
    "readTime": 7,
    "image": "/photos/food.webp",
    "lead": "Хоспер — испанский угольный гриль, который превратился в гастрономический тренд по всему миру. В Петербурге ресторанов с хоспером немного, но именно они дают тот самый вкус мяса «с дымком», который невозможно повторить на обычном гриле.",
    "sections": [
      {
        "heading": "Почему хоспер — это особенно",
        "body": "Хоспер — не просто гриль. Это профессиональная печь на натуральных углях с точным контролем температуры. Продукт готовится при высокой температуре (до 300°C) с живым огнём снизу и раскалёнными углями сверху — корочка получается с ароматом дыма, сок запечатывается внутри. Результат: стейк с карамелизированной корочкой и сочной серединой, рыба с хрустящей кожей и нежным мясом.",
        "list": [
          "Натуральный уголь даёт дымный аромат, который невозможно сымитировать",
          "Двустороннее нагревание создаёт идеальную корочку",
          "Высокая температура «запечатывает» соки внутри",
          "Большинство продуктов на хоспере вкуснее, чем на сковороде"
        ]
      },
      {
        "heading": "Хоспер в «Парусах на крыше»",
        "body": "Ресторан «Паруса на крыше» (ул. Марата, 5, 6 этаж) использует хоспер для приготовления мясных блюд. Стейки, рёбра, рыба — всё это готовится на живом угле. В сочетании с панорамой города и живой музыкой ужин с блюдами с хоспера становится полноценным гастрономическим событием. Средний чек 1 300 ₽.",
        "highlight": "Если вы никогда не пробовали стейк с хоспера — «Паруса» предоставят такую возможность с видом на Петербург."
      },
      {
        "heading": "Что ещё готовят на хоспере",
        "body": "Кроме мяса хоспер отлично подходит для рыбы (лосось, морской окунь), морепродуктов, овощей и даже некоторых десертов. О том, что такое хоспер подробнее — читайте в нашей <a href='/blog/khosper-myaso-vid-peterburg' class='underline text-accent'>статье о хоспере</a>."
      }
    ],
    "cta": { "text": "Забронировать ужин с мясом на хоспере", "href": "/menu" }
  },
  {
    "slug": "restorany-fermerskie-produkty-peterburg",
    "title": "Рестораны с фермерскими продуктами в Петербурге",
    "metaTitle": "Рестораны с фермерскими продуктами Петербург 2026 | Паруса на крыше",
    "metaDescription": "Рестораны с фермерскими продуктами в Санкт-Петербурге: где используют местные и органические ингредиенты.",
    "keywords": "рестораны фермерские продукты петербург, рестораны локальные продукты спб, фермерская кухня ресторан петербург",
    "date": "2026-06-02",
    "category": "Рестораны Петербурга",
    "readTime": 7,
    "image": "/photos/food.webp",
    "lead": "Тренд на локальные и фермерские продукты в ресторанном бизнесе — не мода, а осознанный выбор. Короткая цепочка поставок означает более свежие продукты, поддержку местных производителей и более интересные вкусы. В Петербурге несколько ресторанов серьёзно работают с фермерами.",
    "sections": [
      {
        "heading": "Что значит «фермерские продукты» в меню",
        "body": "Настоящие фермерские продукты — это не просто маркетинг. Это прямой договор с конкретным фермером, постоянный поставщик мяса или молочки, сезонные овощи и зелень с огорода. Такие продукты дороже, но вкус и качество заметно выше. Северо-западный регион богат фермерской продукцией: псковские фермы, ленинградские хозяйства, карельская рыба.",
        "list": [
          "Прямые поставки с ферм — без промежуточных звеньев",
          "Сезонность: меню меняется по доступности продуктов",
          "Псковская область, Ленобласть, Карелия — основные поставщики",
          "Рыба и молочные продукты — главные strengths северо-запада"
        ]
      },
      {
        "heading": "Подход «Парусов» к продуктам",
        "body": "«Паруса на крыше» (ул. Марата, 5) работают с авторским меню, которое обновляется сезонно. Сезонность — ключевой признак работы с живыми, а не замороженными продуктами. Карпаччо, морепродукты, рыба — ингредиенты выбираются по качеству, а не по цене. Именно это отражается в стабильном рейтинге 5,0 при 2 606 отзывах."
      },
      {
        "heading": "Как отличить настоящее от маркетинга",
        "body": "Признаки настоящего фермерского ресторана: меню меняется хотя бы раз в квартал, официант знает происхождение продуктов, в меню есть сезонные позиции «доступно только сейчас». Читайте об авторской кухне Петербурга в нашем <a href='/blog/avtorskaya-kukhnya-peterburg-trendy' class='underline text-accent'>материале о гастрономических трендах</a>."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/menu" }
  },
  {
    "slug": "restorany-vegetarianskoe-menu-peterburg",
    "title": "Рестораны с вегетарианским меню в Петербурге",
    "metaTitle": "Рестораны вегетарианское меню Петербург 2026 | Паруса на крыше",
    "metaDescription": "Рестораны с вегетарианским меню в Санкт-Петербурге: где найти вкусные вегетарианские блюда в ресторане.",
    "keywords": "рестораны вегетарианское меню петербург, вегетарианские рестораны спб, вегетарианская кухня петербург",
    "date": "2026-06-02",
    "category": "Рестораны Петербурга",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Вегетарианство и веганство в России выросли за последнее десятилетие. Рестораны адаптируются: теперь вегетарианское меню — не редкость, а стандарт для любого уважающего себя заведения. Петербург в этом плане — один из самых гибких городов России.",
    "sections": [
      {
        "heading": "Что предлагают вегетарианцам рестораны",
        "body": "Уровни вегетарианских опций в ресторанах: базовый (несколько позиций в общем меню, часто салаты), средний (отдельный раздел «без мяса» с 5–8 блюдами), продвинутый (полноценная вегетарианская секция с горячим, закусками и десертами). Лучшие рестораны готовы адаптировать блюда под запрос гостя — убрать мясо, заменить соус.",
        "list": [
          "Базовый уровень: 2–3 салата и овощная паста",
          "Средний: отдельный раздел с 5–8 блюдами",
          "Продвинутый: полноценное вегетарианское меню",
          "Лучший вариант: ресторан, готовый адаптировать блюда"
        ]
      },
      {
        "heading": "В «Парусах на крыше» для вегетарианцев",
        "body": "В меню «Парусов» есть вегетарианские позиции: салаты, паста без мяса, ризотто, овощные закуски, десерты. При предварительном запросе шеф может адаптировать ряд блюд. Главный плюс — всё это с видом на Петербург. Для тех, кто ищет вегетарианский ужин с атмосферой — стоящий выбор. Подробнее: <a href='/blog/est-li-vegetarianskoe-menyu-v-parusakh' class='underline text-accent'>есть ли вегетарианское меню в «Парусах»</a>."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/menu" }
  },
  {
    "slug": "restorany-srednego-klassa-peterburg",
    "title": "Рестораны среднего класса в Петербурге: где поесть",
    "metaTitle": "Рестораны среднего класса Петербург 2026 | Паруса на крыше",
    "metaDescription": "Рестораны среднего класса в Санкт-Петербурге: средний чек 1000–2000 рублей, хорошая кухня и атмосфера.",
    "keywords": "рестораны среднего класса петербург, рестораны средний чек 1000 спб, рестораны цена качество петербург",
    "date": "2026-06-02",
    "category": "Рестораны Петербурга",
    "readTime": 7,
    "image": "/photos/interior.webp",
    "lead": "Ресторан среднего класса — это золотая середина: не кафе самообслуживания, но и не место, где один ужин бьёт по бюджету на месяц. Средний чек 1 000–2 000 ₽/человек, достойная кухня, хороший сервис. В Петербурге таких мест много — и «Паруса на крыше» входят в их число.",
    "sections": [
      {
        "heading": "Что такое ресторан «среднего класса» в Петербурге",
        "body": "По петербургским меркам 2026 года ресторан среднего класса — это средний чек на человека от 900 до 2 000 ₽ за ужин с напитками. При этом ожидается: авторское или как минимум качественно исполненное меню, профессиональный сервис, достойный интерьер, возможность полноценного бронирования.",
        "list": [
          "Средний чек: 900–2 000 ₽/человек",
          "Кухня: авторская или качественная классика",
          "Сервис: профессиональный, не навязчивый",
          "Атмосфера: соответствует цене — не «кафешка»"
        ]
      },
      {
        "heading": "«Паруса на крыше» — ресторан среднего класса с панорамой",
        "body": "Средний чек в «Парусах» — около 1 300 ₽/человек. Бизнес-ланч в будни — от 590 ₽. По петербургским меркам это средний сегмент, но с несопоставимо более высоким «видовым» бонусом: 6-й этаж, 300° панорама, Казанский собор в окне. Рейтинг 5,0 при 2 606 отзывах — лучший показатель в своём сегменте.",
        "highlight": "Соотношение вид + кухня + сервис к цене в «Парусах» — одно из лучших в центре города. Это подтверждают отзывы: гости неизменно отмечают, что «получили больше, чем ожидали»."
      },
      {
        "heading": "Как выбрать ресторан среднего класса",
        "body": "Ориентируйтесь не только на ценник, но на соотношение цены и впечатления. Иногда ресторан с чеком 1 500 ₽ оставляет воспоминание на годы, а за 3 000 ₽ — разочарование. Читайте наш обзор о <a href='/blog/restorany-cena-kachestvo-spb' class='underline text-accent'>ресторанах с хорошим соотношением цена/качество</a>."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "gde-vkusno-nedorogo-tsentr-peterburg",
    "title": "Где вкусно и недорого поесть в центре Петербурга",
    "metaTitle": "Где вкусно и недорого поесть в центре Петербурга 2026 | Паруса",
    "metaDescription": "Где вкусно и недорого поесть в центре Санкт-Петербурга: лучшие рестораны с ценами до 1000 рублей на человека.",
    "keywords": "где вкусно недорого поесть центр петербург, недорогие рестораны центр спб, вкусно и дёшево петербург центр",
    "date": "2026-06-02",
    "category": "Рестораны Петербурга",
    "readTime": 7,
    "image": "/photos/food.webp",
    "lead": "Центр Петербурга — дорогой по городским меркам. Но «недорого» не всегда означает «плохо» и наоборот. Покажем, где в центре города можно поесть вкусно без переплаты.",
    "sections": [
      {
        "heading": "Стратегия экономии в центре",
        "body": "Три проверенных способа поесть недорого в центре Петербурга: бизнес-ланч (12:00–16:00, будние дни), стрит-фуд у рынков и мест притяжения, столовые и буфеты при бизнес-центрах. Для полноценного ужина в центре «недорого» — это реально до 1 300 ₽/человек, если уйти на 2–3 улицы от Невского.",
        "list": [
          "Бизнес-ланч: лучшая цена за качество в будни",
          "Стрит-фуд и рынки: быстро и неплохо",
          "Боковые улицы от Невского: 20–30% дешевле",
          "Ужин в будни: часто дешевле, чем в выходные"
        ]
      },
      {
        "heading": "Бизнес-ланч в «Парусах» — недорого и с видом",
        "body": "Ресторан «Паруса на крыше» (ул. Марата, 5) предлагает бизнес-ланч от 590 ₽ в будние дни. За эту цену — полноценный обед с видом на панораму города с 6-го этажа. Это лучшее соотношение «вид + кухня + цена» в центре Петербурга. Рейтинг 5,0, 2 606 отзывов.",
        "highlight": "590 ₽ за бизнес-ланч с видом на Казанский собор — это не скидка, это стандартная цена будних обедов. Приходите с 12:00 до 16:00."
      },
      {
        "heading": "Улица Марата — ресторанный квартал",
        "body": "Улица Марата — одна из лучших ресторанных улиц центра: разнообразная кухня, умеренные цены, нетуристическая атмосфера. Здесь можно найти всё — от кавказской кухни до японских суши. «Паруса» — на вершине этого квартала в буквальном смысле: 6-й этаж. Читайте о <a href='/blog/restorany-ulitsa-marata-spb' class='underline text-accent'>ресторанах улицы Марата</a>."
      }
    ],
    "cta": { "text": "Забронировать бизнес-ланч", "href": "/" }
  }
];
